import {Period} from '../../common/model/period.model';
import {EntitaOrganizzativa} from '../../+anagrafica/entitaorganizzativa/entitaorganizzativa.model';
import {Ruolo} from '../ruolo/ruolo.model';
import {TableRow} from '../../common/model/table-row.model';
import {TableRowValue} from '../../common/model/table-row-value.model';
import {Helpers} from '../../common/helpers/helpers';
import {Utente} from '../utente/utente.model';

export class RuoloUtente extends Period {

  constructor(protected id: number,
                public utente: Utente,
                public ruolo: Ruolo,
                public entitaOrganizzativa: EntitaOrganizzativa,
                public note: string,
                public provvedimento: string,
                public attivo: boolean,
                public delega: boolean,
                public inizioValidita: string,
                public fineValidita: string,
                public indennita: boolean,
                public importoIndennita: number,
                public soal: boolean
  ) {
    super(id, inizioValidita, fineValidita);
  }

  public static getTableKeys() {
    return ['utente', 'entitaorganizzativa', 'ruolo', 'contesti', 'Inizio', 'Fine'];
  }

  public toTableRow(): TableRow {
    const rowValues = new Map();
    rowValues.set('utente', new TableRowValue(this.utente.getLabel(), null));
    rowValues.set('entitaorganizzativa', new TableRowValue(this.entitaOrganizzativa ? this.entitaOrganizzativa.getLabel() : null, null));
    rowValues.set('ruolo', new TableRowValue(this.ruolo.getLabel(), null));
    rowValues.set('contesti', new TableRowValue(this.ruolo.getContesti(), null));
    rowValues.set('Inizio', new TableRowValue(Helpers.formatDateView(this.getInizio()), null));
    rowValues.set('Fine', new TableRowValue(Helpers.formatDateView(this.getFine()), null));
    return new TableRow(this, rowValues);
  }

  public getLabel() {
    const entitaLabel = this.entitaOrganizzativa ?  ' - ' + this.entitaOrganizzativa.getLabel() : '';
    return 'Assegnazione ' + this.ruolo.getLabel() + ' - ' + this.utente.getLabel() + entitaLabel;
  }

}

